// extracted by mini-css-extract-plugin
module.exports = {"container":"v_side_bar_container__3xjNq","item":"v_side_bar_item__3OstQ","item_active":"v_side_bar_item_active__3sLOQ"};